const navLinks = document.querySelectorAll('[data-tablink]');
const navContent = document.querySelectorAll('[data-tab-content]');

const removeTabActiveClass = () => {
  navLinks.forEach((el) => {
    el.classList.remove('is-active');
  });
  navContent.forEach((el) => {
    el.classList.remove('is-active');
  });
};

navLinks.forEach((ev, index) => {
  ev.addEventListener('click', () => {
    removeTabActiveClass();
    ev.classList.add('is-active');
    navContent[index].classList.add('is-active');
  });
});
